import { Navigate, useLocation } from 'react-router-dom'
import PATHS from '@/routes/paths'

/** `/` → `/home`, keeping `?code=` (and any other query) intact. */
export default function RootRedirect() {
  const location = useLocation()
  return <Navigate to={{ pathname: PATHS.HOME, search: location.search }} replace />
}
